module.exports = __webpack_public_path__ + "static/media/Boton_accion.c15edf74.png";